import { getChannelsOptions, selectActiveChannels } from '@/modules/Channels';
import { RootState } from '@/store';
import { ISelectProps, Select } from '@/ui';
import { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

type ChannelsSelectProps = ISelectProps<number | number[] | string | string[], number | string> & {
  filterCurrentChannel?: boolean;
  activeOnly?: boolean;
};

export const ChannelsSelect: FC<ChannelsSelectProps> = ({
  filterCurrentChannel = true,
  activeOnly = false,
  value = [],
  ...props
}) => {
  const currentChannel = useSelector((state: RootState) => state.channels.channel);
  const channels = useSelector((state: RootState) => state.channels.channels);
  const activeChannels = useSelector(selectActiveChannels);
  const options = [
    { value: 0, label: 'All channels' },
    ...getChannelsOptions(activeOnly ? activeChannels : channels),
  ].filter((ch) => (filterCurrentChannel ? currentChannel?.id !== ch.value : true));

  const resolveTagLabel = useCallback(
    (id: number | string) => channels?.find((channel) => channel.id === id)?.name,
    [channels],
  );

  const [selectedChannels, setSelectedChannels] = useState<number[]>(value as number[]);

  const handleChannelChange = (selected: number[]) => {
    let updatedSelection = selected;

    if (selected.includes(0)) {
      updatedSelection = [0];
    }

    setSelectedChannels(updatedSelection);

    if (props.onChange) {
      props.onChange(updatedSelection);
    }
  };

  return (
    <Select
      mode="multiple"
      options={options}
      resolveTagLabel={resolveTagLabel}
      {...props}
      value={selectedChannels}
      disabled={selectedChannels.includes(0)}
      onChange={handleChannelChange}
    />
  );
};
